import { requiredArg } from './args';

export const DetailedError = (name = requiredArg('name'), message) =>
  class extends Error {
    constructor(detailedMessage) {
      super();
      this.name = name;

      this.message =
        this.name +
        (typeof detailedMessage === 'string' ? ': ' + detailedMessage : '') +
        (typeof message === 'string' ? '\n↳ ' + message : '');
    }
  };
